<template>
  <div :class="['tab-group', css]">
    <!-- OLD VERSION BY EYAL
    <div :class="['tab-group--bar','py-l','mb-l',children.length < 4 ? 'minor' : '']">
      <a
        href="#p"
        :class="[activeIndex === index ? 'active' : '', 'text--s']"
        v-for="(tab, index) in children"
        :key="tab.title"
        v-text="tab.title"
        @click.prevent="activateTab(tab, index)">
      </a>
    </div>
    <keep-alive>
      <tab-content
        @img-loaded="imageLoadedCB"
        @tab-changed="$emit('content-loaded')"
        v-bind="activeTab"
        :tab-index="activeIndex"
      ></tab-content>
    </keep-alive>
    -->
    <!-- TEST BY DUBI
    <publication-list :children="children" :has-search="false">
    </publication-list>
    -->

    <!-- NEW VERSION BY DUBI -->
    <div v-for="(tab, index) in children" 
        :key="tab.title" 
        :id="tab.title" 
        :panel-index="index"
        :class="['tab-group--panel','border-botttom', isOpen(index) ? 'open' : '']">
          <i @click="togglePanel(index)" class="toggler text--m"
            :class="[isOpen(index) ? 'open' : '',isOpen(index) ? 'fal fa-minus' : 'fal fa-plus' ]"
          ></i>
          <h3 @click="togglePanel(index)" v-text="tab.title" class="inpanel-title text--l"></h3>

          <div :class="['pt-m','pb-l','tab-wrapper']" style="padding-left:10px;">
            <tab-content
              :ref="`panel-comp-inner-${index}-${tab.id}`"   
              :tab-index="index" v-bind="tab">
            </tab-content>
          </div>

    </div>
    

  </div>
</template>
<script>
import TabContent from "./TabContent.vue";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    css: String
  },
  components: {
    TabContent
  },
  data() {
    return {
      activeTab: null,
      activeIndex: 0,
      panelsStates:[],
      panelHeights:[],
      _openPanelsIndexes:[]
    };
  },
  created() {
    this.activeTab = this.children[0];
    for (let x in this.children) {
      this.panelsStates.push(0);
    }
  },
  computed: {
    openPanelsIndexes: {
      get() {
        return this._openPanelsIndexes;
      },
      set(value) {
        this.$set(this, "_openPanelsIndexes", value);
      }
    },
    closedPanelHeight()
    {
      return "10vh";
      return this.size === "large"
        ? "13vh"
        : this.size === "medium"
        ? "9vh"
        : "7vmax";
    },
    _panelsStates: {
      get() {
        return this.panelsStates;
      },
    }
  },

  methods: {
    isOpen(index)
    {
      return this.openPanelsIndexes.indexOf(index) > -1;
      //return this.panelsStates[index] == 0 ? '' : 'open';
    },
    activateTab(tab, index) {
      this.activeIndex = index;
      this.activeTab = tab;
    },
    imageLoadedCB() {
      console.log("image loaded >>>> ");
      this.$emit("content-loaded");
    },

    //Added by dubi
    getPanelID(index){
      return 'panel_'+index.toString();
    },
    togglePanel(index) {
      //var isPanelOpen = this.isOpen(index);
      var itemID = this.children[index].title;  
      
      var panelEl = document.getElementById(itemID);        
      var openAtt = panelEl.getAttribute("data-open");

      var togglerIcon = panelEl.getElementsByClassName('toggler')[0];   

      //CHANGE THE PANEL HEIGHT
      if(openAtt=="1")
      {        
        var closedHeight = this.closedPanelHeight;//this.panelHeights[index].close;///undefined!
        panelEl.style.maxHeight = closedHeight;   
        panelEl.setAttribute("data-open","0");
        panelEl.className = "tab-group--panel border-botttom";
        togglerIcon.className = "toggler text--m fal fa-plus";
      }else
      {
        //open panel        
        //alert("this.$refs="+this.$refs.length);
        var openedHeight =  this.panelHeights[index].open;
        //alert("openedHeight="+openedHeight);
        panelEl.style.maxHeight = openedHeight+"px";        
        panelEl.setAttribute("data-open","1");
        panelEl.className = "tab-group--panel open border-botttom";
        togglerIcon.className = "toggler text--m fal fa-minus";     
      }
      this.$emit("content-loaded"); //must call this to expend the tree !!!
      
      
      let _panels = _.clone(this.openPanelsIndexes);
      let _i = _panels.indexOf(index);
      if (_i > -1) {
        _panels.splice(_i, 1);
      } else {
        _panels.push(index);
      }
      this.$set(this, "openPanelsIndexes", _panels);
    },
    togglePanel_temp(index) 
    {
      var curVal = this.panelsStates[index];
      this.$set(this.panelsStates, index, curVal==0 ? 1 : 0);
      this.$emit("content-loaded");//tell the parent container to change the heignt       
      //this.activeIndex = index;
    },
    isOpen(index) {
      //return this.openPanels.indexOf(index) > -1;
    },
    setPanelHeights: _.debounce(function(e) 
    {            
      //this.setHeightForPanels();      
      // console.log(
      //   "MAYBE CONTENT LOADED SET PANEL HEIGHTS!!!!",
      //   " :: ",
      //   this.$refs
      // );      
     let halfScreenHeight = window.innerHeight / 2;
      this.panelHeights = _.map(this.$refs, function(ref) {
        let el = ref.$el || ref[0].$el,ttl = el.previousElementSibling,buffer = 120;
        return {
          open: el
            ? Math.max(halfScreenHeight, el.offsetHeight + buffer)
            : null,
          closed: ttl ? ttl.offsetHeight + 40 : null
        };
      });
    }, 600),


    setHeightForPanels()
    {
      let halfScreenHeight = window.innerHeight / 2;
      this.panelHeights = _.map(this.$refs, function(ref) {
        let el = ref.$el || ref[0].$el,
          ttl = el.previousElementSibling,
          buffer = 120;
        return {
          open: el
            ? Math.max(halfScreenHeight, el.offsetHeight + buffer)
            : null,
          closed: ttl ? ttl.offsetHeight + 40 : null
        };
      });
    }
  },
  mounted() 
  {
    //This comp has a Similar logic of PanelGroup
    //let imgs = document.querySelectorAll("img");
    // console.log("IMGS > ", imgs);
    //this.$set(this, "openPanelsIndexes", []);
    this.$set(this, "_openPanelsIndexes", []);
    setTimeout(
      function() 
      {
        this.setHeightForPanels();
        //this.setPanelHeights();//debounce
      }.bind(this),600);

      //RESET HIGHTS FOR ALL ITEMS
      for (let index = 0; index < this.children.length; ++index) 
      {
          const element = this.children[index];
          var itemID = element.title;//"Dimensions";
          var panelEl = document.getElementById(itemID);

          panelEl.style.maxHeight = this.closedPanelHeight;
          panelEl.setAttribute("data-open", "0");
      }
    }
};

</script>

<style>
  .inpanel-title
  {
     /*font-size: 18px !important;*/
     padding-left: 10px;
  }
  .tab-group--panel:last-child
  {
    border:0px;
  }
  .tab-group--panel .tab-wrapper
  {
    opacity: 0;
  }
  .tab-group--panel.open .tab-wrapper
  {
    opacity: 1 !important;
  }

  @media only screen and (max-width: 600px) {
    .content-block--text ol
    {
      padding-left: 0px !important;
    }
    .slider-gallery .slider-btn
    {
      display: none;
    }
  }
</style>

<!-- NEW VERSION BY DUBI -->
<style lang="stylus">
.border-botttom
  border-bottom 1px solid gray_2
  +below(815px)
    border-bottom 0px solid 
.tab-group
  +below(815px)
    &:not(:first-child)
      padding-top 4vmax
  &--panel
    _flex(row, wrap, center, flex-end)
    //border-bottom 1px solid gray_2
    overflow hidden
    position relative
    transform-style preserve-3d
    will-change max-height
    transition max-height 0.6s ease-out-cubic
    padding-top 20px
    i
      color c_primary
    h3
      color c_primary
      cursor pointer
      font-weight 200
      // transform translateY(-8%)
      +below(42em, orientation: portrait)
        transform none
    & > *
      flex 0 0 97%
      +below(840px)
        flex 0 0 96%
      +below(600px)
        flex 0 0 94%
    .content-block--text
      pad('xl', right)
      li
        pad('l', bottom)
        strong
          display block
          pad('xs',bottom)
    .toggler
      cursor pointer
      flex 0 0 3%
      width 2vmin
      position relative
      display block
      transform-origin center center
      transform-style preserve-3d
      will-change transform
      transition transform 0.4s ease-out-cubic
    .panel-content
      transform-style preserve-3d
      will-change padding
      transition padding 0.6s ease-out-cubic
      overflow hidden
    &.open
      max-height 68vh
      .panel-content
        pad('xl',top)
</style>


<!-- old version by eyal
<style lang="stylus">
.tab-group
	&--bar
    border-top 1px solid gray_2
    border-bottom 1px solid gray_2
    _flex(row, wrap, flex-start, flex-start)
    // +above(415px)
    +above(1200px)
      _flex(row, wrap, center, space-between)
      &.minor
        _flex(row, wrap, center, flex-start)
        a
          pad('2xl',right)

    a
      color gray_6
      text-align left
      // flex 0 0 25%
      pad('xl',right)
      margin-left 10px
      +below(600px)
        margin-left 0px
      &:first-child
        margin-bottom 10px
        margin-left 0
        +below(600px)
          margin-bottom 0px
      +above(1200px)
        flex initial
        pad('0',right)
        margin-bottom 0 !important
      &.active
        color c_primary
</style>
-->